import axiosInstance from '../../api/axios.js';
import type { OrgModuleAccess } from '../../constants/moduleAccess.ts';

export async function fetchOrgModuleAccess(): Promise<OrgModuleAccess> {
  const { data } = await axiosInstance.get('/api/org-membership/module-access');
  return {
    role: String(data?.role ?? ''),
    feature_keys: Array.isArray(data?.feature_keys) ? data.feature_keys : [],
    unrestricted: Boolean(data?.unrestricted),
    reporting_enabled: Boolean(data?.reporting_enabled),
    has_own_ai_credentials: Boolean(data?.has_own_ai_credentials),
    widgets_demo_data: Boolean(data?.widgets_demo_data),
  };
}
